export enum B2bPresumedOrderAmount {
	LessThanFour = "LessThanFour",
	FiveToTen = "FiveToTen",
	MoreThanTen = "MoreThanTen",
}

export const b2bCustomerPresumedOrderAmountNameMap: Record<B2bPresumedOrderAmount, string> = {
	[B2bPresumedOrderAmount.LessThanFour]: "0–4",
	[B2bPresumedOrderAmount.FiveToTen]: "5–10",
	[B2bPresumedOrderAmount.MoreThanTen]: "11 a více",
};
